import React                             from 'react';
import { CombinationMoleculeSchemaType } from "@geenee/geeclient-kit/src/lib/type/section-molecule";
import { SiteMoleculeSchemaType }        from '../../packages/shared/lib/type/model/site-molecule';
import { createObservableContext }       from '../../packages/shared/lib/util/context/_helpers/create-observable-context';

export const MoleculeContext: React.Context<
  SiteMoleculeSchemaType |
  CombinationMoleculeSchemaType>  =  createObservableContext({} as SiteMoleculeSchemaType | CombinationMoleculeSchemaType);
